import { render, staticRenderFns } from "./ModalLogDetalhado.vue?vue&type=template&id=39b065ef"
import script from "./ModalLogDetalhado.vue?vue&type=script&lang=js"
export * from "./ModalLogDetalhado.vue?vue&type=script&lang=js"
import style0 from "./ModalLogDetalhado.vue?vue&type=style&index=0&id=39b065ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports